import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const nav = useNavigate();
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 800 }}>
          404
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          Page not found.
        </Typography>
        <Button sx={{ mt: 2 }} variant="contained" onClick={() => nav("/")}>
          Go Home
        </Button>
      </Paper>
    </Box>
  );
}
